import React from "react";
import Sidebar from "../components/sidebar/Sidebar";
import Header from "../components/header/Header";
import { Outlet } from "react-router-dom";

const MatxLayout = () => {
  return (
    <div>
      <div className="flex gap-0">
        <Sidebar />
        <div className="w-full">
          <Header />
          <div>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MatxLayout;
